import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-initial_loader',
  templateUrl: './initial_loader.component.html',
  styleUrls: ['./initial_loader.component.scss']
})
export class Initial_loaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
